
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rent-estimate",
      function () {
        return require("private-next-pages/rent-estimate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rent-estimate"])
      });
    }
  